import {
    AspectRatio,
    Center,
    ChakraProvider,
    ColorModeScript,
    Flex,
    Grid,
    GridItem,
    HStack, InputLeftAddon,
    Link,
    SimpleGrid, Stack,
    useToast,
} from '@chakra-ui/react'
import React, {useRef, useState} from 'react';
import {
    Box,
    Button,
    Card,
    CardBody, CardFooter,
    Divider,
    Editable, EditableInput,
    EditablePreview,
    Heading, Input,
    InputGroup,
    Text,
    Textarea, VStack,
} from "@chakra-ui/react";
import {keyframes} from "@emotion/react";
import {useInViewport} from "react-in-viewport";
import styled from "styled-components";
const ResponsiveVideo = styled.video`
  width: 90vw;
  height: 50vw;
  max-width: 900px;
  max-height: 500px;
  background: #0f0f0f;
  border-radius: 12px;

  @media (min-width: 1200px) and (orientation: landscape) {
    width: 30vw;
    height: 500px;
  }
  @media (max-width: 600px), (orientation: portrait) {
    width: 90vw;
    height: 240px;
  }
`;
function About(){
    const title_style_1 = { base: "18px", sm:"44px", md: "4vh", lg: "31px", "2xl":"35px"};
    return (
        <>
            <Box paddingTop = "100px" paddingBottom = "100px" >
                <Heading paddingBottom = "70px" fontSize={title_style_1}>MJ Carpentry and Joinery</Heading>
                <Text fontSize={"20px"}>
                    English and Australia background in carpentry and joinery have more than 20 years of working experience as
                    experts in providing highly Qualified and Licensed Carpentry and joinery Services.
                </Text>
                <br></br>
                <br></br>

                <ResponsiveVideo controls autoPlay muted>
                    <source src="videos/coverpage.mp4" type="video/mp4" />
                    Your browser does not support video.
                </ResponsiveVideo>
            </Box>

        </>
    )
}

export default About;